
import Select from "react-select";



const FilterSelect = ({options, value, isMulti=false, placeholder, isLoading, optionLabel, optionValue, onChange, isClearable, className, isDisabled=false, defaultValue, menuPlacement="auto", noOptionsLabel="employees"}) => {

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), /* Ensures visibility */
    menuList: (base) => ({
      ...base,
      maxHeight: "300px", // Limit menu height for better performance
      overflowY: "auto", // Enable vertical scrolling
      overflowX: "hidden"
    }),
    option: (provided, state) => ({
      
      ...provided,
      backgroundColor: state.isFocused ? "#D3001A" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#D3001A",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      flexWrap: "nowrap",      // single row, no wrapping
      overflowX: "auto",        // horizontal scroll when many chips
      overflowY: "hidden",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      gap: isMulti ? 4 : 0,
      // hide horizontal scrollbar visually but keep scroll capability
      scrollbarWidth: "thin",
    }),
    multiValue: (provided) => ({
      ...provided,
      flexShrink: 0,            // chips keep their natural width
      borderRadius: 6,
      background: "rgba(211,0,26,0.08)",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#1F1F1F",
      fontWeight: 500,
      whiteSpace: "nowrap",
      overflow: "visible",      // show full name within the chip
      textOverflow: "clip",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#6B7280",
      "&:hover": { background: "rgba(211,0,26,0.16)", color: "#D3001A" },
    }),
    control: (base) => ({
      ...base,
      minHeight: 40,
      fontSize: 12,
    }),
  };


  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     display: "flex",
  //     overflow: "hidden"
  //   }),
  //   valueContainer: (provided) => ({
  //     ...provided,
  //     display: "flex",
  //     flexWrap: "nowrap", // Prevent wrapping
  //     overflowX: "auto", // Enable horizontal scrolling
  //     whiteSpace: "nowrap",
  //     maxWidth: "100%"
  //   }),
  //   multiValue: (provided) => ({
  //     ...provided,
  //     marginRight: "4px" // Space between selected items
  //   })
  // };

  
  return (

          <div className=" form-focus select-focus">
            <Select
            defaultValue={defaultValue}
            isDisabled={isDisabled || isLoading}
            isClearable={isClearable}
            isSearchable={true}
            onChange={onChange}
                getOptionLabel={option => option[optionLabel]}
                getOptionValue={option => option[optionValue]}
              isLoading={isLoading}
              menuPlacement={menuPlacement}
              options={options}
              placeholder={isLoading ? "Loading…" : placeholder}
              styles={customStyles}
              value={value}
              isMulti={isMulti}
              className={className}
              menuPortalTarget={document.body} /* Fix dropdown being hidden */
              filterOption={(option, inputValue) => {
                if (!inputValue) return true;
                const needle = inputValue.toLowerCase();
                const label = option.data[optionLabel];
                if (typeof label === 'string' && label.toLowerCase().includes(needle)) return true;
                // Also match any other string/number field on the option (e.g. emp_no, email)
                for (const key in option.data) {
                  if (key === optionLabel || key === optionValue) continue;
                  const v = option.data[key];
                  if (v == null) continue;
                  if (typeof v === 'string' || typeof v === 'number') {
                    if (String(v).toLowerCase().includes(needle)) return true;
                  }
                }
                return false;
              }}
              noOptionsMessage={({ inputValue }) => 
                inputValue ? `No ${noOptionsLabel} found matching "${inputValue}"` : `No ${noOptionsLabel} available`
              }
            />
            {/* <label className="focus-label">Designation</label> */}
          </div>
       
  );
};

export default FilterSelect;
